<div class="row px-0 mx-0 h-100">

  <div class="col-lg-6">
    <!-- init header content -->
    <div class="row my-3">
      <div class="col-md-12">
        <button *ngIf="ShowSaveButton" class="q-btn q-success" title="Enregistrer" (click)="SaveResa()">
          <i class="fas icon fa-save"></i>
        </button>
        <button *ngIf="ShowRemoveButton && param.model.IdDonneeFils !== '0'" class="q-btn q-danger" title="Supprimer" data-toggle="modal" data-target="#ModalDelete" #modalDeleteBtn>
          <i class="fas fa-trash-alt"></i>
        </button>
        <button *ngIf="zoom && ShowSaveButton" class="q-btn q-primary ml-5" title="sauvegarder et ouvrir les options de vidéo-conférence" (click)="saveResaAndOpenZoom()">
          <i class="fas fa-video mr-2"></i>
          Salle Virtuelle
        </button>
      </div>
    </div>
    <!-- end  header content -->
    <div class="row">
      <div class="col-12">
        <select *ngIf="Stages && Stages.length > 0" [disabled]="disableSelect" [(ngModel)]="selectedStage" (change)="OnstageChange()" class="w-100 m-2 q-main-select">
          <option *ngFor="let stage of Stages" [ngValue]="stage.BOModel.IdDonneeFils">du {{qDateService.ToDate(stage.dtDebut) | date: 'mediumDate' : '' : indParam.AppParams.culture}} au {{qDateService.ToDate(stage.dtFin) | date: 'mediumDate' : '' : indParam.AppParams.culture}} - {{stage.Text}}</option>
        </select>
      </div>
    </div>

    <div class="row w-100">
      <div class="col-md-12">
        <q-bodisplay [param]="param" [globalsave]="globalSaveStage" (sendEvent)="getIdBoRdv($event)" (boReady)="pageLoaded()"></q-bodisplay>
      </div>
    </div>

  </div>

  <div class="col-lg-6">

    <!--imite l'architecture du bo pour s'y aligner-->
    <div *ngIf="param?.model?.IdDonneeFils && param?.model?.IdDonneeFils != '0'" class="row">
      <div class="col-md-12">
        <h5 class="emargement-title">Emargement</h5>
      </div>
      <div class="col-md-12">
        <ng-container *ngIf="!reloadEmargementFormateur">
          <q-signature *ngIf="signatureAllowed"
                       [signatureDisabled]="indParam.AppParams.LoggedUser.Ident != param.model.IdDonneePere"
                       [idPere]="param.model.IdDonneePere"
                       [idFils]="param.model.IdDonneeFils"
                       width="300px"
                       height="150px"
                       nomRel="REL_BO_CNX_BO_RESERV"
                       mode="FORMATEUR_RESERV"
                       (fileExist)="EmargementFormateurExist = $event">
          </q-signature>
          <ng-container *ngIf="!signatureAllowed">
            <span class="q-c-main detail">(Ce stage n'a pas encore eu lieu)</span>
          </ng-container>
        </ng-container>
      </div>
      <div *ngIf="EmargementFormateurExist" class="col-md-12 mt-2">
        <button *ngIf="!deletingSignature && indParam.AppParams.LoggedUser.Ident == param.model.IdDonneePere" class="q-btn q-danger" (click)="DeleteStgSignature(param.model.IdDonneePere, param.model.IdDonneeFils, 'REL_BO_CNX_BO_RESERV')"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
        <button *ngIf="deletingSignature" class="q-btn q-danger"><i class="fas fa-spin fa-pulse fa-spinner mr-2"></i>Supprimer la signature</button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12 mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">{{ 'learner' | trad }}</th>
              <th scope="col"></th>
              <th scope="col" title="Inscrit"><input type="radio" value="PI" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('PI');">&nbsp;Inscrit</th>
              <th scope="col" title="{{ 'present' | trad}}"><input type="radio" value="P" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('P');">&nbsp;Pres.</th>
              <th scope="col" title="{{ 'absent' | trad }}"><input type="radio" value="A" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('A');">&nbsp;Abs.</th>
              <th scope="col" title="{{ 'unjustified' | trad }}"><input type="radio" value="AI" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('AI');">&nbsp;Abs. Injust.</th>
              <th scope="col"><input type="radio" value="" [ngModel]="globalPresence" name="headcoll" class="d-none"></th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let Apprenant of Apprenants; let i = index">
              <th scope="row">
                <p class="mb-0"> <span class="q-c-main">{{Apprenant.strNom}} {{Apprenant.strPrenom}}</span>{{Apprenant.strNumeroTelFixe ? " - " + Apprenant.strNumeroTelFixe : ''}}{{Apprenant.strNumeroTelPortable ? " - " + Apprenant.strNumeroTelPortable : ''}}</p>
                <p class="q-email-apprenant">{{Apprenant.strEmail ? Apprenant.strEmail : ''}}</p>
              </th>
              <td>
                <div *ngIf="Apprenant.pathEmargement"
                     [ngbPopover]="f1"
                     [placement]="['auto', 'auto']"
                     autoClose="outside"
                     container="body"
                     #p1="ngbPopover"
                     class="q-pointer"
                     style="border: 2px solid var(--c-main);">
                  <div class="w-100 h-100" ngbPopover="{{ Apprenant.infoEmargement}}" [disablePopover]="p1.isOpen()" triggers="mouseenter:mouseleave">
                    <!--<i class="fas fa-signature fa-2x q-c-main"></i>-->
                    <img *ngIf="!Apprenant.pathExistButUnfounded" style="max-width: 48px;max-height: 48px" [src]="sanitize.bypassSecurityTrustResourceUrl(Apprenant.pathEmargement)" />
                    <i *ngIf="Apprenant.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
                  </div>
                  <ng-template #f1>
                    <img *ngIf="!Apprenant.pathExistButUnfounded" [src]="sanitize.bypassSecurityTrustResourceUrl(Apprenant.pathEmargement)" />
                    <i *ngIf="Apprenant.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
                    <button *ngIf="!deletingSignature" class="q-btn q-danger" (click)="DeleteStgSignature(Apprenant.strIdent, baseModel.EventId, 'REL_BO_CONTACT_BO_RESERV_P', Apprenant)"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
                    <button *ngIf="deletingSignature" class="q-btn q-danger"><i class="fas fa-spin fa-pulse fa-spinner mr-2"></i>Supprimer la signature</button>
                  </ng-template>
                </div>
              </td>
              <td><input type="radio" value="PI" [ngModel]="Apprenant.presence" (click)="UpdatePresence('PI', Apprenant)" name="{{i}}" /></td>
              <td><input type="radio" value="P" [ngModel]="Apprenant.presence" (click)="UpdatePresence('P', Apprenant)" name="{{i}}" /></td>
              <td><input type="radio" value="A" [ngModel]="Apprenant.presence" (click)="UpdatePresence('A', Apprenant)" name="{{i}}" /></td>
              <td><input type="radio" value="AI" [ngModel]="Apprenant.presence" (click)="UpdatePresence('AI', Apprenant)" name="{{i}}" /></td>
              <td><input class="d-none" type="radio" value="" [ngModel]="Apprenant.presence" name="{{i}}" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal suppression fichier -->
<div class="modal fade" id="ModalDelete" tabindex="-1" role="dialog" aria-labelledby="ModalDelete" aria-hidden="true" #deleteModal>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title ml-3"> Suppression d'une Réservation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalDelete()" #closeDelete>
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <br />
          <div class="row justify-content-center">
            Voulez-vous vraiment supprimer cette réservation ?
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="row">
                <div class="col-md-6 text-center">
                  <button type="button" class="btn btn-success" (click)="confirmDelete()">Oui <i class="fas fa-check ml-2"></i></button>
                </div>
                <br />
                <div class="col-md-6 text-center">
                  <button type="button" class="btn btn-danger" (click)="closeModalDelete()">Non <i class="fas fa-times ml-2"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
